import { IGetVillageListRequestSchema } from '../../../node/repositories/countryside-search/entities/schemas/GetVillageListRequestSchema';

type TExtraFilters = Pick<
  IGetVillageListRequestSchema,
  | 'areaFrom'
  | 'areaTo'
  | 'floorCountFrom'
  | 'floorCountTo'
  | 'heatingSourceType'
  | 'houseMaterialType'
  | 'otherCommunications'
  | 'readyStatus'
  | 'saleStatus'
  | 'wcLocationType'
  | 'commuteDistanceType'
  | 'commuteKmFrom'
  | 'commuteKmTo'
>;

export const DEFAULT_EXTRA_FILTERS: TExtraFilters = {
  areaFrom: undefined,
  areaTo: undefined,
  floorCountFrom: undefined,
  floorCountTo: undefined,
  heatingSourceType: undefined,
  houseMaterialType: undefined,
  otherCommunications: undefined,
  readyStatus: undefined,
  saleStatus: undefined,
  wcLocationType: undefined,
  commuteDistanceType: undefined,
  commuteKmFrom: undefined,
  commuteKmTo: undefined,
};
